import React from 'react';
import { useDispatch } from 'react-redux';
import { marcarOnboardingCompleto } from '../../actions/auth';

export const SuscripcionCancelada = () => {
    const dispatch = useDispatch();

    return (
        <div className="app-container" style={{ position: 'relative' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '32px 24px' }}>
                <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'var(--pink-100)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 34, marginBottom: 16 }}>
                    😕
                </div>
                <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--pink-900)', marginBottom: 8, textAlign: 'center' }}>
                    No completaste el registro
                </h1>
                <p style={{ fontSize: 14, color: 'var(--pink-800)', lineHeight: 1.7, marginBottom: 24, textAlign: 'center' }}>
                    No te preocupes, puedes intentarlo de nuevo cuando quieras. Tu negocio está guardado.
                </p>
                <button
                    className="btn-primary"
                    style={{ width: '100%' }}
                    onClick={() => dispatch(marcarOnboardingCompleto())}
                >
                    Volver a intentarlo
                </button>
            </div>
        </div>
    );
};
